var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAssessmentEditor = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "klFSxd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.19,3.26h10.57c.49,0,1.24.77,1.24,1.24v14.26c0,.59-.75,1.33-1.38,1.33h-7.07v3.26h2.55c.22,0,.39.58-.14.63H7.26c-.54-.05-.37-.63-.14-.63h2.55v-3.26H2.6c-.22,0-.73-.24-.9-.38-.16-.13-.49-.59-.49-.77v-3.69c-.58.06-1.13-.1-1.21-.7L.03.55C.11.28.45.02.75,0h8.35s.18.11.18.11c.41.54,2.8,2.35,2.9,2.82.02.11,0,.22.01.33ZM8.65.63H.8s-.09.07-.1.09v13.81s.09.09.1.09h10.59c.07-.04.07-.09.08-.16.07-.56-.06-1.24,0-1.82V3.31s-2.26,0-2.26,0c-.21,0-.56-.27-.56-.48V.63ZM9.33,1.13v1.49h1.65l-1.65-1.49ZM23.32,16.66V4.55c0-.23-.46-.66-.7-.66h-10.42v10.66c0,.23-.4.7-.66.7H1.89v1.4h21.42ZM23.32,17.34H1.89v1.47s.1.2.12.25c.27.44.69.33,1.16.41,6.5-.04,13.02.08,19.52-.06.24-.04.62-.43.62-.64v-1.43ZM14.87,20.1h-4.52v3.26h4.47v-3.19s.07-.05.05-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.17,5.23c.03-.11.35-.29.48-.18l3.86,3.6c.07.13,0,.27-.09.36l-3.69,3.44c-.14.2-.56,0-.56-.16v-1.65h-3.81c-.2,0-.3-.22-.32-.38-.09-.97.08-2.06,0-3.04-.04-.1.21-.29.27-.29h3.86v-1.7ZM18.85,11.41l2.81-2.64-2.81-2.61v1.2s-.17.2-.22.2h-3.91v2.4h3.86c.06,0,.27.2.27.25v1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.93,10.74l8.4.03c.38.14.25.62-.15.64H2.02c-.5-.02-.56-.55-.09-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.71,6.03c.06-.05.17-.05.25-.06l8.43.03c.27.11.18.64-.17.61H1.97c-.32,0-.48-.38-.25-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.48,9.25c.15.17.07.53-.2.53H1.92s-.22-.07-.22-.07c-.2-.25-.07-.54.27-.57h8.34s.15.08.17.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.88,7.57h8.35c.45,0,.44.61,0,.63H1.92c-.38-.07-.42-.51-.04-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.48,4.92c-.06.06-.26.1-.35.1H2.06c-.38,0-.59-.26-.36-.57l.22-.07h8.36c.27-.01.35.39.2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.83,12.37h6.11c.44.04.35.65-.1.62H1.97c-.41-.04-.49-.44-.13-.62Z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAssessmentEditor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/assessment-editor.a1fbd44dcfe01c740bdb4bb1841a7d46.svg";